module.exports = __webpack_public_path__ + "src/assets/img/paper-3.3c894763.svg";